import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import Icons from 'components/icons';
import { Localize } from 'components/service';


const StandGraphicGraphicField = ({ stand }) => {

    const fileListItem = [
        {
            field: 'file_graphic',
            label: <Localize>ACTIONS.List_Item_Label_Graphic</Localize>,
        },
    ]
        .map(({ field, label }) => {
            const fileName = stand?.[field]?.split('/')?.pop()?.split('~')?.pop();

            return (
                <li key={field}>
                    {stand?.[field] ? (
                        <div className='download-file'>
                            <Tooltip overlayClassName="craft-tooltip" destroyTooltipOnHide={true} title={fileName}>
                                <Link
                                    to='#'
                                    onClick={() => {
                                        window.open(
                                            stand?.[field],
                                            '_blank'
                                        );
                                    }}
                                >
                                    <Icons.Download /> <span className='link-text'>{label}</span>
                                </Link>
                            </Tooltip>
                        </div>
                    ) : (
                        <span className='no-file'>&mdash;</span>
                    )}
                </li>
            );
        });


    return (
        <ul className='download-file-list'>

            { fileListItem }

        </ul>

    );
};

export default StandGraphicGraphicField;
